(function () {
  'use strict';

  var component = {
    template:'<div class="hq-lighting-list-item__container"><div class="hq-lighting-list-item" data-translate-key="{{$ctrl.option.translateKey}}"><div ng-if="!$ctrl.zoomModal" class="hq-lighting-list-item__image"><img ng-src="/themes/mieux-consommer/images/eclairage/item-{{$ctrl.option.translateKey}}.svg" alt="{{$ctrl.option.translateKey | translate}}"></div><div ng-if="$ctrl.zoomModal" class="hq-lighting-list-item__image"><button ng-click="$ctrl.action({ translateKey: $ctrl.option.id })"><img ng-src="/themes/mieux-consommer/images/eclairage/item-{{$ctrl.option.id}}.png" alt="{{$ctrl.option.translateKey | translate}}"></button></div><div class="hq-lighting-list-item__title">{{$ctrl.option.translateKey | translate}} <span data-ng-if="$ctrl.option.popular" class="hq-lighting-list-item__popular">{{ \'MOST_POPULAR\' | translate }}</span></div><div class="hq-lighting-list-item__radio"><div class="hq-lighting-list-item__radio-button"></div></div></div></div>',
    bindings: {
      action: '&',
      option: '<',
      zoomModal: '<',
    },
  };

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingCarouselItem', component);
}());
